var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fontscale-editor" },
    [
      _c(
        "KeyValue",
        { attrs: { label: "Font Size" } },
        [
          _c("bInputSelector", {
            attrs: { value: _vm.computedFontSize, defaultOptions: ["inherit"] },
            on: { change: _vm.onFontSizeChange }
          })
        ],
        1
      ),
      _c(
        "KeyValue",
        { attrs: { label: "Line Height" } },
        [
          _c("bInputSelector", {
            attrs: {
              value: _vm.computedLineHeight,
              defaultOptions: ["inherit"]
            },
            on: { change: _vm.onLineHeightChange }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }